import React, { useEffect } from "react";
import { Content } from "../components";
import TableSkeleton from "../Skeletons/TableSkeleton";
import AddEditModal, {
  AddEditModalState,
  IaddEditModalStates,
} from "../pageComponents/RtmPlan/AddEditModal";
// import ShowTemplateModal, {
//   ShowTemplateModalState,
// } from "../pageComponents/RtmPlan/ShowTemplateModal";
import {
  CustomTableRow,
  Table,
  TableBody,
  TableButtons,
  TableHead,
  TableNoContent,
  TableRowTitle,
  TableStatusWithToggle,
} from "../components/NewTable";
import Pagination from "../components/NewTable/Pagination";
import DeleteModal, {
  DeleteModalState,
  IdeleteModalStates,
} from "../pageComponents/RtmPlan/DeleteModal";
import { useDebounce } from "use-debounce";
import ToggleModal from "../pageComponents/RtmPlan/ToggleModal";
import { RTMPlanTableHeadData } from "../hooks/rtm_plan/staticData";
import useAddRTMPlan from "../hooks/rtm_plan/useAddRTMPlan";
import useGetAllRTMPlan from "../hooks/rtm_plan/useGetAllRTMPlan";
import useDeleteRTMPlan from "../hooks/rtm_plan/useDeleteRTMPlan";
import useToggleRTMPlan from "../hooks/rtm_plan/useToggleRTMPlan";
import useAllBillingCycle from "../hooks/rtm_plan/useAllBillingCycle";
import useAllFrequency from "../hooks/rtm_plan/useAllFrequency";
import useFetchAllProcess from "../hooks/rtm_plan/useFetchAllProcess";

import { useFetchStatus } from "../hooks/patients";
import { IRTMPlanRequest } from "../hooks/rtm_plan/index.type";
import ListHeader from "../components/ListHeader/ListHeader";


const RtmPlan = () => {
  const [pageNumber, setPageNumber] = React.useState<number>(1);
  const perpageData = 10;
   const [searchKey, setSearchKey] = React.useState<string>("");
   const [debouncedSearchKey] = useDebounce(searchKey, 300);
   const [filters, setFilters] = React.useState<Record<string, string>>({});
    React.useState<string>("");

  const { fetchingStatus, fetchStatus, status } = useFetchStatus();
  // template modal
  // const [showTemplateModal, setShowTemplateModal] =
  //   React.useState<ShowTemplateModalState>({
  //     status: false,
  //   });

  // ====================================== Add edit states start ======================================
  const [addEditModal, setAddEditModal] = React.useState<AddEditModalState>({
    status: false,
  });
  const startAddEditModalStatesValue: IaddEditModalStates = {
    name: { value: "", error: "" },
    // templateIds: { value: [], error: "" },
     templateIds: { value:'', error: "" },
    type: { value: "", error: "" },
    billingCycle: { value: "", error: "" },
    frequency: { value: "", error: "" },
    custom: { value: "", error: "" },
    timezone: { value: "", error: "" },
    time: { value: "", error: "" },
    isContinueuseBilling: false,
    intakeFormId: { value: "", error: "" } 
  };
  const [addEditModalStates, setAddEditModalStates] =
    React.useState<IaddEditModalStates>(startAddEditModalStatesValue);
  // ====================================== Add edit states end ======================================

  // ====================================== Toggle states start ======================================
  const [toggleModal, setToggleModal] = React.useState<DeleteModalState>({
    status: false,
  });
  // ====================================== Toggle states end ======================================

  // ====================================== Delete states start ======================================
  const [deleteModal, setDeleteModal] = React.useState<DeleteModalState>({
    status: false,
  });

  const startDeleteModalStatesValue = {
    name: { value: "", error: "" },
  };

 const [sortConfig, setSortConfig] = React.useState<{
        key: string;
        direction: "asc" | "desc";
      }>({
        key: "",
        direction: "asc",
      });
  const [deleteModalStates, setDeleteModalStates] =
    React.useState<IdeleteModalStates>(startDeleteModalStatesValue);
  // ====================================== Delete states end ======================================

  // ====================================== Hooks ======================================
  const { RTMPlanData, getRTMPlanData, RTMPlanDataLoading } = useGetAllRTMPlan({
    pageNumber,
    perpageData,
    search: debouncedSearchKey,
    frequency:filters.frequency || "",
    status:filters.status || "",
    billingCycle:filters.billingcycle || "",
    sort: sortConfig.key,
    order: sortConfig.direction,
  });
  const { billingCycleLoading, billingCycleOption, getBillingCycleOption } = useAllBillingCycle();
  const {frequencyLoading,frequency, getFrequency } = useAllFrequency();
  const { addRTMPlanLoading, addRTMPlan } = useAddRTMPlan({
    RTMPlanId: addEditModal.data?._id,
  });
  const { deleteRTMPlanLoading, deleteRTMPlan } = useDeleteRTMPlan({
    RTMPlanId: deleteModal.data?._id,
  });
  const { toggleRTMPlanLoading, toggleRTMPlan } = useToggleRTMPlan({
    RTMPlanId: toggleModal.data?._id,
  });

    const { getProcessType,processType,processTypeLoading } = useFetchAllProcess();
  // ======================================fetching plan type======================================

  useEffect(() => {
    getBillingCycleOption()
    getFrequency()
    fetchStatus()
    getProcessType()
  }, []);

    useEffect(() => {
    getRTMPlanData()
  }, [filters,debouncedSearchKey,pageNumber,perpageData]);

  
  let filter = [
    {
      id: "1",
      disable: false,
      label: "Billing Cycle",
      value: "billingcycle",
      options: [
        { label: "Billing Cycle", value: "" },
        ...(billingCycleOption || [])?.map((type) => ({
          label: type.value,
          value: type.key,
        })),
      ],
      loading:billingCycleLoading
    },
    {
      id: "2",
      disable: false,
      label: "Frequency",
      value: "frequency",
      options: [
        { label: "Frequency", value: "" },
        ...(frequency || [])?.map((fre) => ({
          label: fre.value,
          value: fre.key,
        })),
      ],
      loading:frequencyLoading
    },
    {
      id: "3",
      disable: false,
      label: "Status",
      value: "status",
      options: [
        { label: "Status", value: "" },
        ...(status || []).map((status) => ({
          label: status.value,
          value: status.key,
        })),
      ],
      loading:fetchingStatus
    },
  ];

  const handleFiltersUpdate = (newFilters: Record<string, string>) => {
    setFilters(newFilters);
  };



  const handleSearch = (searchTerm: string) => {
    setSearchKey(searchTerm);
  };


  // pagination
  const onPageChange = (currentPage: { selected: number }) => {
    setPageNumber(currentPage.selected + 1);
  };
  // pagination

  // add
  useEffect(() => {
    if (addEditModal.status && addEditModal.data) {
   
      setAddEditModalStates({
        name: { value: addEditModal.data.name || "", error: "" },
        templateIds: {
          value: addEditModal.data.transmissionTemplateId._id || "",
          error: "",
        },
        type: { value: addEditModal.data.type || "", error: "" },
        billingCycle: {
          value: addEditModal.data.billingCycle || "",
          error: "",
        },
        frequency: {
          value:
            addEditModal.data.frequency,
          error: "",
        },
        // custom: {
        //   value:
        //     addEditModal.data.frequency?.days !== "Daily"
        //       ? addEditModal.data.frequency?.days
        //       : "",
        //   error: "",
        // },
        timezone:{value:addEditModal.data.timezone || "", error: "" },
        time: { value: addEditModal.data.time || "", error: "" },
        isContinueuseBilling: addEditModal.data.isContinueuseBilling || false,
        intakeFormId: { value: addEditModal.data.intakeFormId._id || "", error: "" }
      });
    } else if (!addEditModal.status) {
      setAddEditModalStates(startAddEditModalStatesValue);
    }
  }, [addEditModal]);

  const handleCloseModal = () => {
    setAddEditModal({ status: false });
    setAddEditModalStates(startAddEditModalStatesValue);
  };

  const handleAddRTMPlanAPI = async (formData: IRTMPlanRequest) => {
    const data = await addRTMPlan(formData);
    if (data?.status === "success") {
      handleCloseModal();
      getRTMPlanData();
    }
  };

  const handleAddRTMPlan = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
   

    // Form validation
    if (!addEditModalStates.name.value) {
      setAddEditModalStates((prevVal) => ({
        ...prevVal,
        name: { ...prevVal.name, error: "Please enter RTM Plan name" },
      }));
      return;
    }
    if (!addEditModalStates.templateIds.value) {
      setAddEditModalStates((prevVal) => ({
        ...prevVal,
        templateIds: {
          ...prevVal.templateIds,
          error: "Please select at least one template",
        },
      }));
      return;
    }
    if (!addEditModalStates.type.value) {
      setAddEditModalStates((prevVal) => ({
        ...prevVal,
        type: { ...prevVal.type, error: "Please select SMS send type" },
      }));
      return;
    }

    if (!addEditModalStates.billingCycle.value) {
      setAddEditModalStates((prevVal) => ({
        ...prevVal,
        billingCycle: {
          ...prevVal.billingCycle,
          error: "Please enter billing cycle",
        },
      }));
      return;
    }

    if (!addEditModalStates.frequency.value) {
      setAddEditModalStates((prevVal) => ({
        ...prevVal,
        frequency: { ...prevVal.frequency, error: "Please select frequency" },
      }));
      return;
    }

      if (!addEditModalStates.timezone.value) {
      setAddEditModalStates((prevVal) => ({
        ...prevVal,
        time: { ...prevVal.timezone, error: "Please select time zone" },
      }));
      return;
    }

    if (!addEditModalStates.time.value) {
      setAddEditModalStates((prevVal) => ({
        ...prevVal,
        time: { ...prevVal.time, error: "Please enter time" },
      }));
      return;
    }

    // if (addEditModalStates.frequency.value === 'Custom') {
    //   setAddEditModalStates(prevVal => ({ ...prevVal, custom: { ...prevVal.custom, error: 'Please select custom days' } }));
    //   return;
    // }

    const formData: IRTMPlanRequest = {
      name: addEditModalStates.name.value,
      templateId: addEditModalStates.templateIds.value,
      type: addEditModalStates.type.value,
      billingCycle: addEditModalStates.billingCycle.value,
      frequency:addEditModalStates.frequency.value,
      // custom: addEditModalStates.custom.value,
       isContinueuseBilling: addEditModalStates.isContinueuseBilling,
      timezone:addEditModalStates.timezone.value,
      time: addEditModalStates.time.value.includes(":")
        ? addEditModalStates.time.value
        : `${addEditModalStates.time.value}:00`,
        intakeFormId: addEditModalStates.intakeFormId.value, 
    };
    // if (addEditModalStates.frequency.value === "Custom") {
    //   formData["Custom"] = addEditModalStates.custom.value;
    // }

    handleAddRTMPlanAPI(formData);
  };
  // add

  //  toggle
  const handleToggleRTMPlan = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    if (toggleModal.data) {
      const data = await toggleRTMPlan({
        isActive: !toggleModal.data.isActive,
      });
      if (data?.status === "success") {
        setToggleModal({ status: false });
        getRTMPlanData();
      }
    }
  };
  // toggle

  // delete
  const handleCloseDeleteModal = () => {
    setDeleteModal({ status: false });
    setDeleteModalStates(startDeleteModalStatesValue);
  };

  const handleDeleteRTMPlan = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    if (deleteModal.data) {
      if (!deleteModalStates.name.value.trim()) {
        setDeleteModalStates((prevVal) => ({
          ...prevVal,
          name: { ...prevVal.name, error: "Please enter valid name" },
        }));
      } else {
        const data = await deleteRTMPlan();
        if (data?.status === "success") {
          handleCloseDeleteModal();
          getRTMPlanData();
        }
      }
    } else {
      setDeleteModalStates((prevVal) => ({
        ...prevVal,
        name: { ...prevVal.name, error: "Please select RTM Plan to delete" },
      }));
    }
  };

  // delete

  const handleAddRTMPlan1 = () => {
    setAddEditModal({ status: true });
  };

  const handleFilterChange = (filterId: string, value: string) => {
    console.log("");
    // Apply filtering logic
  };

  const convertTo12HourFormat = (time24:string) => {
    const [hour, minute] = time24.split(":");
    const hourNum = parseInt(hour, 10);
    const period = hourNum >= 12 ? "PM" : "AM";
    const hour12 = hourNum % 12 || 12;
    return `${hour12}:${minute} ${period}`;
  };

  
       const sortedPlan = React.useMemo(() => {
        if (!RTMPlanData?.plans) return [];
        return [...RTMPlanData.plans];
      }, [RTMPlanData]);
  
      
      const handleSort = (key: string) => {
        setSortConfig((prev) => {
          if (prev.key === key) {
            return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
          }
          return { key, direction: "asc" };
        });
        setPageNumber(1); 
      };
    

  return (
    <Content
      currentMenu="RTM"
      headerTitle=""
      list={true}
    >
      <ListHeader
        title="Plans"
        searchPlaceholder="Search plans..."
        actionButtonText="Add RTM Plan"
        onActionButtonClick={handleAddRTMPlan1}
        onFilterChange={handleFilterChange}
        actionType="add"
        filterOptions={filter}
        setFilters={handleFiltersUpdate}
        onSearchChange={handleSearch}
        showFilter={true}
      
      />

      <Table >
        <TableHead data={RTMPlanTableHeadData}  rowStyle={{borderBottom:'none' }}   
        sortKey={sortConfig?.key || ""}
        sortOrder={sortConfig?.direction || "asc"}
        onSort={handleSort} />
        <TableBody>
          <CustomTableRow>
            {RTMPlanDataLoading ? (
              <TableSkeleton rows={RTMPlanTableHeadData.length} columns={5} />
            ) : RTMPlanData && RTMPlanData?.totalPlans > 0 ? (
              RTMPlanData?.plans?.map((plan) => (
                <tr key={plan._id} style={{padding:"0.5rem 0.5rem"}}>
                  <td style={{padding:"1rem 0.5rem"}}></td>
                  <TableRowTitle>{plan.name}</TableRowTitle>
                
                  <td >{plan.transmissionTemplateId?.name}</td>
                  
                  <td>{plan.type.charAt(0).toUpperCase() + plan.type.slice(1)}</td>

                  <td>{plan.frequency.charAt(0).toUpperCase() + plan.frequency.slice(1)}</td>
                 <td >{plan.timezone ? plan.timezone : "N/A"}</td>
                  <td >{convertTo12HourFormat(plan.time)}</td>
                  <td >{plan.billingCycle}</td>
                  <td >{plan.isContinueuseBilling ? 
                    <p style={{backgroundColor:"#D1FAE5",color:"#065F460",width:"4rem",borderRadius:"50rem",padding:"0.2rem 2rem",display:"flex",justifyContent:"center",alignItems:"center",fontSize:"1.2rem",fontWeight:'500'}}>Yes</p>
                  : <p style={{backgroundColor:"#FEE2E2",color:"#991B1B",width:"4rem",borderRadius:"50rem",padding:"0.2rem 2rem",display:"flex",justifyContent:"center",alignItems:"center",fontSize:"1.2rem",fontWeight:'500'}}>No</p>

                     }</td>
                  <td>{plan?.intakeFormId?.name}</td>
                  <td >
                    <TableStatusWithToggle
                       toggleCustomStyle={{cursor:"pointer"}}
                      id={plan._id}
                      status={plan.isActive ? 'Active' : 'Inactive'}
                      // checked={template.status === "active"}
                      checked={plan.isActive}
                      onChange={() =>
                        setToggleModal({ status: true, data: plan })
                      }
                    />
                  </td>

                  <TableButtons
                  customStyle={{paddingLeft:'2.5rem'}}
                    buttons={[
                      {
                        icon: "update",
                        tooltip: "Edit RTM Plan",
                        onClick: () =>
                          setAddEditModal({ status: true, data: plan }),
                      },
                 
                    ]}
                  />
                  <td ></td>
                </tr>
              ))
            ) : (
              <TableNoContent
                colSpan={RTMPlanTableHeadData?.length}
                message={
                  searchKey
                    ? "No RTM Plans found matching your search"
                    : "No RTM Plans found"
                }
              />
            )}
          </CustomTableRow>
        </TableBody>
      </Table>
      <Pagination 
        itemsPerPage={perpageData}
        totalItems={RTMPlanData ? RTMPlanData.totalPlans : 0}
        onPageChange={onPageChange}
      />
      {addEditModal.status && (
        <AddEditModal
          loading={addRTMPlanLoading}
          addEditModal={addEditModal}
          onCloseModal={handleCloseModal}
          addEditModalStates={addEditModalStates}
          setAddEditModalStates={setAddEditModalStates}
          handleAddEdit={handleAddRTMPlan}
          billingCycle={billingCycleOption}
          billingCycleLoading={billingCycleLoading}
          frequency={frequency}
          frequencyLoading={frequencyLoading}
          processType={processType}
          processTypeLoading={processTypeLoading}
        />
      )}
      {toggleModal.status && (
        <ToggleModal
          loading={toggleRTMPlanLoading}
          toggleModal={toggleModal}
          onCloseModal={() => setToggleModal({ status: false })}
          handleToggle={handleToggleRTMPlan}
        />
      )}
      {deleteModal.status && (
        <DeleteModal
          loading={deleteRTMPlanLoading}
          deleteModal={deleteModal}
          deleteModalStates={deleteModalStates}
          setDeleteModalStates={setDeleteModalStates}
          onCloseModal={handleCloseDeleteModal}
          handleDelete={handleDeleteRTMPlan}
        />
      )}

    </Content>
  );
};

export default RtmPlan;
